import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { colorChoicesPage, seo } from "../data/siteData";

export default function ColorChoices() {
  useSeo(seo["/color-choices"].title, seo["/color-choices"].description);
  useReveal();
  const [zoom, setZoom] = useState(null);

  return (
    <>
      <section className="border-b-4 border-[#244aa2] bg-[#f7f7f7] py-12">
        <div className="mr-container text-center">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{colorChoicesPage.h1}</h1>
          <Link
            to="/contact-us"
            className="mt-6 inline-block bg-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-[#0c2a66]"
          >
            Contact Us
          </Link>
        </div>
      </section>

      <section className="bg-white py-14">
        <div className="mr-container-wide grid gap-6 sm:grid-cols-2">
          {colorChoicesPage.freehand.map((src, i) => (
            <button
              key={src}
              onClick={() => setZoom(src)}
              className="reveal overflow-hidden shadow-md ring-1 ring-black/5"
            >
              <img
                src={src}
                alt={`Mr. Resurface countertop colour sample board ${i + 1}`}
                className="w-full transition-transform duration-500 hover:scale-105"
              />
            </button>
          ))}
        </div>
      </section>

      <section className="bg-[#f7f7f7] py-14">
        <div className="mr-container-wide">
          <h2 className="mr-h2 reveal mb-8 text-center text-2xl sm:text-3xl">
            Available Countertop Finishes
          </h2>
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
            {colorChoicesPage.colors.map((c) => (
              <button
                key={c.name}
                onClick={() => setZoom(c.image)}
                className="reveal group bg-white p-3 shadow-sm ring-1 ring-black/5 transition-shadow duration-300 hover:shadow-xl"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={c.image}
                    alt={`${c.name} countertop finish`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <h3 className="font-head mt-3 text-[15px] font-bold text-[#244aa2] transition-colors group-hover:text-[#a10000]">
                  {c.name}
                </h3>
              </button>
            ))}
          </div>
        </div>
      </section>

      {zoom && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setZoom(null)}
        >
          <button
            onClick={() => setZoom(null)}
            aria-label="Close"
            className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white hover:bg-white/25"
          >
            <X className="h-6 w-6" />
          </button>
          <img
            src={zoom}
            alt="Countertop finish detail"
            className="max-h-[88vh] max-w-[92vw] object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <CtaBand headline="Not sure which finish to pick?" copy="Visit the Wolcott showroom by appointment to see and feel the samples in person." />
    </>
  );
}
